module.exports = ".table-responsive {\n    margin-top: 15px;\n    overflow-x: unset;\n}\n\n.table-responsive th,\n.table-responsive tr {\n    text-align: center;\n}\n\nh3 {\n    text-transform: uppercase;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/duplicated-leads/duplicated-leads.component.css
// module id = ./src/app/duplicated-leads/duplicated-leads.component.css
// module chunks = main